import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import { User } from '../../shared/core/state/users/models';
import { Subscription } from 'rxjs';
import { getResourcePath } from '../../shared/util/helper.utils';
import * as UserActions from '../../shared/core/state/users/user.actions';
import { UserService } from '../../shared/core/state/users/users.service';
import { ToastService } from '@black/ui';

@Component({
  selector: 'black-tutor-profile-page',
  templateUrl: './tutor-profile-page.component.html',
  styleUrls: ['./tutor-profile-page.component.css'],
  standalone: false,
})
export class TutorProfilePageComponent implements OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  private userService = inject(UserService);
  private toast = inject(ToastService);
  private sub = new Subscription();

  user: Partial<User> | null = null;
  isRefreshing = false;

  get displayUser(): any {
    if (!this.user) return null;
    const profile: any = this.user.profile || {};
    const pending: any = this.user.pendingTutorProfileUpdates || {};

    const tutorInfo = {
      ...(profile.tutorInfo || {}),
      ...(pending.tutorInfo || {}),
    };
    const personal = {
      ...(profile.personal || {}),
      ...(pending.personal || {}),
    };
    const professional = {
      ...(profile.professional || {}),
      ...(pending.professional || {}),
    };

    return {
      ...this.user,
      slug: pending.slug || this.user.slug,
      profile: {
        ...profile,
        personal,
        professional,
        tutorInfo,
      },
    };
  }

  get hasIncompleteTutorProfile(): boolean {
    if (!this.displayUser) return false;
    const tInfo = this.displayUser.profile?.tutorInfo;
    const bio = this.displayUser.profile?.personal?.biography;
    return (
      !tInfo ||
      !tInfo.subjects?.length ||
      !tInfo.whatsAppNumber ||
      !bio ||
      bio.trim() === ''
    );
  }

  ngOnInit(): void {
    this.sub.add(
      this.store
        .select((state) => state.users.user)
        .subscribe((user) => {
          this.user = user;
        }),
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  refreshProfileStatus(): void {
    if (this.isRefreshing) return;
    this.isRefreshing = true;
    this.userService.getUserInfo().subscribe({
      next: (user) => {
        this.isRefreshing = false;
        this.store.dispatch(
          UserActions.updateUserProfileSuccess({ user, redirect: false }),
        );
        this.toast.showToast('Profile status refreshed', 'success');
      },
      error: (err) => {
        this.isRefreshing = false;
        this.toast.showToast(
          err.error?.message || 'Failed to refresh profile status',
          'error',
        );
      },
    });
  }

  getAvatarUrl(avatar: any): string | null {
    if (!avatar) return null;
    return getResourcePath(avatar) || null;
  }

  getBannerUrl(banner: any): string | null {
    if (!banner) return null;
    return getResourcePath(banner) || null;
  }
}
